import { useDialogPlus } from '@/componentsUI/Dialog/dialogPlus';
import { ChevronLeftIcon, CloseIcon } from '@/componentsUI/Icon';
import classNames from 'classnames';
import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';
import './index.less'

export interface DialogPlusHeadProps {
    className?: string | string[];
    /**
     *@zh 标题
     */
    title?: string | ReactNode;

    style?: CSSProperties;

    styleTitle?: CSSProperties;

    styleIcon?: CSSProperties;

    /**右侧扩展操作，渲染在关闭按钮左侧 */
    extra?: ReactNode;

    /**必传 用于关闭指定弹窗标识*/
    dialogName: string;

    /**是否隐藏关闭按钮 */
    isHideClose?: boolean
}

const DialogPlusHead = (props: DialogPlusHeadProps) => {
    const { className, title = 'title', style, styleTitle, styleIcon, extra, dialogName , isHideClose} = props;
    const prefixCls = 'dialog-plus-head';
    const [btnBack, setBtnBack] = useState<boolean>(false)
    const { showBtnBack , closeAll , closeSelf} = useDialogPlus()

    useEffect(() => {
        setBtnBack(showBtnBack(dialogName))
    }, [])
    return (
        <div
            style={style}
            className={
                classNames([
                    `${prefixCls}`,
                    btnBack ? `${prefixCls}-hasback` : '',
                    isHideClose ? `${prefixCls}-no-close` : '',
                    extra ? `${prefixCls}-has-extra` : '',
                    className
                ])
            }
        >
            {btnBack && <button
                type="button"
                className={
                    classNames([
                        `${prefixCls}-back`,
                        `${prefixCls}-button`
                    ])
                }
                onClick={()=>{
                    closeSelf(dialogName)
                }}
            >
                <ChevronLeftIcon style={styleIcon} className={'svg-icon'} />
            </button>}
            <div className={`${prefixCls}-title`} style={styleTitle}>{title}</div>
            {extra && <div className={`${prefixCls}-extra`}>{extra}</div>}
            {!isHideClose && <button
                type="button"
                className={
                    classNames([
                        `${prefixCls}-close-icon`,
                        `${prefixCls}-button`
                    ])
                }
                onClick={()=>{
                    closeAll()
                }}
            >
                <CloseIcon style={styleIcon} className={'svg-icon'} />
            </button>}
        </div>
    );
};

export default DialogPlusHead;
